import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.css";
import logo from "../data/Images/logo.png";

const NotFound = () => {
  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.contentWrapper}>
        {/* 404 Illustration */}
        <div className={styles.errorIllustration}>
          <div className={styles.iconContainer}>
            <img
              src={logo}
              alt="404 Not Found"
              ></img>
          </div>
          <h1 className={styles.errorNumber}>404</h1>
        </div>

        {/* Error Message */}
        <div className={styles.errorMessage}>
          <h2 className={styles.errorTitle}>
            Page Not Found
          </h2>
          <p className={styles.errorDescription}>
            Sorry, the page may have been moved, deleted, Not Found or you may have entered an incorrect URL.
          </p>
        </div>

        {/* Action Buttons */}
        <div className={styles.actionButtons}>
          <Link to="/" className={styles.primaryButton}>
            Go to Homepage
          </Link>
          <button
            onClick={() => window.history.back()}
            className={styles.secondaryButton}
          >
            Go Back
          </button>
        </div>

        {/* Quick Links */}
        <div className={styles.quickLinks}>
          <p className={styles.quickLinksTitle}>
            Looking for something specific?
          </p>
          <div className={styles.linksList}>
            <Link
              to="/admin-login"
              className={styles.quickLink}
            >
              Admin Login
            </Link>
            <span className={styles.linkSeparator}>•</span>
            <Link to="/login" className={styles.quickLink}>
              Employee Login
            </Link>
            
          </div>
        </div>

        {/* WorkFlow Branding */}
        <div className={styles.brandingSection}>
          <span className={styles.brandText}>Flight Reservation Hub</span>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
